import { KNOB_DIRECTIONS } from 'crazyEditor/core/constants/editorConstants';

export default {
  draggable: {y: true},
  hoverable: true,
  resizable: false,
  fullWidth: true,
  selectable: true,
  fontSelectable: true,
  noFontEmphasisAndAlign: true,
  paddingSelectable: true,
  autoHeight: true,
};
